export const supportEmail = "help@signalos.io";
